(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3872,5275],{

/***/ 90269:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ MultiColumnRenderer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/isMobileDevice.ts
var isMobileDevice = __webpack_require__(26910);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/RichTextImage/component/TextEditor.tsx
var TextEditor = __webpack_require__(74232);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/MultiColumn/MultiColumnHelper.ts
var MultiColumnHelper = __webpack_require__(94078);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/Carousel/utils.tsx
var utils = __webpack_require__(58619);
// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/WIdgetPropertiesBasic/components/Button/index.tsx + 1 modules
var Button = __webpack_require__(46976);
// EXTERNAL MODULE: ./src/components/WidgetMaker/utils/buttonConstant.ts
var buttonConstant = __webpack_require__(91850);
// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/utils/btnUtils.js
var btnUtils = __webpack_require__(93080);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/CardFrameCollection/utils.ts
var CardFrameCollection_utils = __webpack_require__(90331);
// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicDesignsUtilities/ContentAnimationStyles.module.scss
var ContentAnimationStyles_module = __webpack_require__(89429);
var ContentAnimationStyles_module_default = /*#__PURE__*/__webpack_require__.n(ContentAnimationStyles_module);
// EXTERNAL MODULE: ./src/context/WidgetDndContext/index.ts
var WidgetDndContext = __webpack_require__(74151);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/MultiColumn/multiColumn.module.scss
var multiColumn_module = __webpack_require__(96268);
var multiColumn_module_default = /*#__PURE__*/__webpack_require__.n(multiColumn_module);
// EXTERNAL MODULE: ./src/utils/getStringFromHtmlTag.ts
var getStringFromHtmlTag = __webpack_require__(35400);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/CommonLinkWrapper/index.tsx
var CommonLinkWrapper = __webpack_require__(86353);
// EXTERNAL MODULE: ./src/constants/builderConstants.ts
var builderConstants = __webpack_require__(79834);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/MultiColumn/index.tsx


















var REMOVE_GLOBAL_STYLE = [
    "circle",
    "arch",
    "blob"
];
var MultiColumnComponent = function(props) {
    var renderIcon = function renderIcon(columnData) {
        var url = columnData.imageDetail.url;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            style: {
                justifyContent: textAlignment,
                minWidth: isMobile ? "".concat(iconSizeMobile, "px") : "".concat(iconSizeDesktop, "px"),
                width: iconPosition === "left" ? isMobile ? "".concat(iconSizeMobile, "px") : "".concat(iconSizeDesktop, "px") : "100%"
            },
            className: "tw-flex tw-w-[100%]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: url || "/assets/icons/multi-column-icon.svg",
                className: (multiColumn_module_default())["custom-border-radius"],
                style: {
                    height: isMobile ? "".concat(iconSizeMobile, "px") : "".concat(iconSizeDesktop, "px"),
                    width: isMobile ? "".concat(iconSizeMobile, "px") : "".concat(iconSizeDesktop, "px")
                }
            })
        });
    };
    var renderImage = function renderImage(data, index) {
        var url = data.imageDetail.url;
        var shapeStyleCalculated = (0,CardFrameCollection_utils/* getShapeStyles */.cw)(imageShape, oneGridCellGeometry === null || oneGridCellGeometry === void 0 ? void 0 : oneGridCellGeometry.width);
        var shapeStyle = shapeStyleCalculated[0];
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classnames_default()("tw-relative tw-flex-shrink-0 tw-overflow-hidden ".concat(!(REMOVE_GLOBAL_STYLE === null || REMOVE_GLOBAL_STYLE === void 0 ? void 0 : REMOVE_GLOBAL_STYLE.includes(imageShape)) ? "imgWrapperGlobalStyle" : ""), shapeStyle.className),
            style: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                width: "".concat((oneGridCellGeometry === null || oneGridCellGeometry === void 0 ? void 0 : oneGridCellGeometry.width) - (appearance === "card" ? 40 : 0), "px"),
                height: "".concat((oneGridCellGeometry === null || oneGridCellGeometry === void 0 ? void 0 : oneGridCellGeometry.height) - (appearance === "card" ? 40 : 0), "px")
            }, shapeStyle.style || {}), {
                justifyContent: textAlignment
            }),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: url || builderConstants/* RICH_TEXT_IMAGE */.O8,
                className: classnames_default()("tw-absolute tw-h-[100%] tw-w-[100%] tw-object-cover tw-transition-all tw-duration-500", (ContentAnimationStyles_module_default())[(0,CardFrameCollection_utils/* getCurrentClass */.WR)(cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.hoverType)], shapeStyle.className)
            })
        });
    };
    var renderIconAndImage = function renderIconAndImage(columnData, index) {
        if ((listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.type) === "icon") {
            return isShow && renderIcon(columnData);
        }
        return isShow && renderImage(columnData, index);
    };
    var onNavigate = function onNavigate(e, index) {
        if (activeWidgetId) {
            handleWidgetPropChange({
                subWidget: "",
                subWidgetIndex: -1
            }, activeWidgetId);
            setTimeout(function() {
                handleWidgetPropChange({
                    subWidget: "multiColumn",
                    subWidgetIndex: index,
                    cardFrame: activeWidgetProps === null || activeWidgetProps === void 0 ? void 0 : activeWidgetProps.cardFrame
                }, activeWidgetId);
            }, 0);
        }
    };
    var renderCustomHtml = function renderCustomHtml(content) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextEditor/* EditableText */.s, {
            content: content,
            className: "tw-leading-[22.4px]"
        });
    };
    var renderTitleAndDescription = function renderTitleAndDescription(columnData) {
        var ref;
        var title = columnData.title, description = columnData.description;
        var titleStyle = (0,MultiColumnHelper/* getTitleStyles */.ij)(cardFrameConfig, isMobile);
        var descriptionStyle = (0,MultiColumnHelper/* getDescriptionStyle */.TV)(cardFrameConfig, isMobile);
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "tw-flex tw-flex-col tw-gap-[8px]",
            children: [
                showTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        color: (cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.titleColor) || ""
                    }, titleStyle === null || titleStyle === void 0 ? void 0 : titleStyle.style), {
                        textAlign: textAlignment
                    }),
                    children: renderCustomHtml(title)
                }),
                showDescription && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        color: cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.descriptionColor
                    }, descriptionStyle === null || descriptionStyle === void 0 ? void 0 : descriptionStyle.style), {
                        textAlign: textAlignment,
                        marginBottom: !(buttonConfig === null || buttonConfig === void 0 ? void 0 : (ref = buttonConfig[0]) === null || ref === void 0 ? void 0 : ref.isShow) ? "16px" : ""
                    }),
                    children: renderCustomHtml(description)
                })
            ]
        });
    };
    var renderButton = function renderButton(columnData) {
        var actionObj = {
            type: (columnData === null || columnData === void 0 ? void 0 : columnData.redirectionType) || "",
            handler: (columnData === null || columnData === void 0 ? void 0 : columnData.redirectUrl) || "",
            newTab: (columnData === null || columnData === void 0 ? void 0 : columnData.isOpenInNewTab) || ""
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "tw-flex ".concat(textAlignment === "center" ? "tw-justify-center" : "", " tw-mb-[16px]"),
            children: buttonConfig === null || buttonConfig === void 0 ? void 0 : buttonConfig.map(function(buttonData, btnIndex) {
                var ref;
                var buttonVariant = (0,utils/* getButtonVariantsData */.Tk)(buttonData, false);
                var selectedButtonType = buttonVariant[buttonData.type];
                var link = buttonData === null || buttonData === void 0 ? void 0 : (ref = buttonData.actions) === null || ref === void 0 ? void 0 : ref.handler;
                return buttonData.isShow ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CommonLinkWrapper/* default */.Z, {
                    link: link,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        size: buttonConstant/* BUTTON_SIZE_TYPE.LARGE */.n6.LARGE,
                        btnType: buttonData.type,
                        buttonData: buttonData,
                        selectedButtonData: selectedButtonType,
                        variant: selectedButtonType.variant,
                        onClick: function() {
                            return (0,btnUtils/* btnActionHandler */.c)(actionObj, function() {});
                        },
                        className: "tw-text-[14px] !tw-py-[12px] !tw-min-w-[148px]",
                        children: buttonData === null || buttonData === void 0 ? void 0 : buttonData.text
                    }, btnIndex)
                }) : null;
            })
        });
    };
    var ref, ref1, ref2;
    var listPresentationConfig = props.listPresentationConfig, cardFrameConfig = props.cardFrameConfig, oneGridCellGeometry = props.oneGridCellGeometry, columnData = props.columnData, index = props.index;
    var ref3 = (0,WidgetDndContext/* useWidgetDndContextData */.KX)(), widgetContextState = ref3.widgetContextState, handleWidgetPropChange = ref3.widgetContextHelpers.handleWidgetPropChange;
    var widgets = widgetContextState.widgets, activeWidgetId = widgetContextState.activeWidgetId;
    var activeWidget = widgets === null || widgets === void 0 ? void 0 : widgets[activeWidgetId];
    var activeWidgetProps = activeWidget === null || activeWidget === void 0 ? void 0 : activeWidget.props;
    var isMobile = (0,isMobileDevice/* isMobileDevice */.s)();
    var iconSizeDesktop = cardFrameConfig.iconSizeDesktop, iconSizeMobile = cardFrameConfig.iconSizeMobile, iconPosition = cardFrameConfig.iconPosition, iconAlignment = cardFrameConfig.iconAlignment, showTitle = cardFrameConfig.showTitle, showDescription = cardFrameConfig.showDescription, buttonConfig = cardFrameConfig.buttonConfig, textAlignment = cardFrameConfig.textAlignment, imageShape = cardFrameConfig.imageShape, isShow = cardFrameConfig.isShow;
    var appearance = listPresentationConfig.appearance, borderColor = listPresentationConfig.borderColor, backgroundColor = listPresentationConfig.backgroundColor;
    var isSelected = (activeWidgetProps === null || activeWidgetProps === void 0 ? void 0 : activeWidgetProps.subWidgetIndex) === index && (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.type) === (activeWidgetProps === null || activeWidgetProps === void 0 ? void 0 : (ref = activeWidgetProps.listPresentation) === null || ref === void 0 ? void 0 : ref.type);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        onClick: function(e) {
            e.preventDefault();
            onNavigate(e, index);
            return;
        },
        className: "tw-flex tw-w-[100%]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            style: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, appearance === "card" ? {
                border: isSelected ? "1px solid #2B74D8" : "1px solid ".concat(borderColor || "black"),
                background: backgroundColor,
                padding: isMobile ? "20px 14px" : "24px 20px"
            } : {}, appearance !== "card" && isSelected ? {
                border: "1px solid #2B74D8"
            } : {}), {
                width: oneGridCellGeometry === null || oneGridCellGeometry === void 0 ? void 0 : oneGridCellGeometry.width
            }),
            className: "tw-flex tw-relative tw-gap-[20px] tw-mx-auto tw-cursor-pointer\n          ".concat(iconPosition === "left" ? "tw-flex-row ".concat(iconAlignment === "center" ? "tw-items-center" : "tw-justify-start") : " tw-flex-col ", "\n          ").concat(appearance === "card" ? "imgWrapperGlobalStyle" : "", "\n          "),
            children: [
                isSelected && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tw-absolute tw-top-[-27.5px] tw-left-0 tw-w-[108px] tw-bg-[#2F80ED] tw-px-[12px] tw-py-[4px] tw-text-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "tw-text-[14px] tw-font-normal tw-text-[#fff]",
                        children: "Column ".concat((activeWidgetProps === null || activeWidgetProps === void 0 ? void 0 : activeWidgetProps.subWidgetIndex) + 1)
                    })
                }),
                renderIconAndImage(columnData, index),
                (showTitle && (0,getStringFromHtmlTag/* getTitleWithoutTags */.f)(columnData === null || columnData === void 0 ? void 0 : columnData.title) || showDescription && (0,getStringFromHtmlTag/* getTitleWithoutTags */.f)(columnData === null || columnData === void 0 ? void 0 : columnData.description) || (buttonConfig === null || buttonConfig === void 0 ? void 0 : (ref1 = buttonConfig[0]) === null || ref1 === void 0 ? void 0 : ref1.isShow)) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-flex tw-flex-col tw-gap-[20px]",
                    children: [
                        (showTitle && (0,getStringFromHtmlTag/* getTitleWithoutTags */.f)(columnData === null || columnData === void 0 ? void 0 : columnData.title) || showDescription && (0,getStringFromHtmlTag/* getTitleWithoutTags */.f)(columnData === null || columnData === void 0 ? void 0 : columnData.description)) && renderTitleAndDescription(columnData),
                        (buttonConfig === null || buttonConfig === void 0 ? void 0 : (ref2 = buttonConfig[0]) === null || ref2 === void 0 ? void 0 : ref2.isShow) && renderButton(columnData)
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var MultiColumn = (MultiColumnComponent);

// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/context/ListPresentationContext.tsx + 15 modules
var ListPresentationContext = __webpack_require__(1657);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/components/MultiColumnRenderer/index.tsx



function MultiColumnRenderer() {
    var data = (0,ListPresentationContext/* useListPresentationContextData */.ds)();
    var _state = data.state, iterableList = _state.iterableList, listPresentationConfig = _state.listPresentationConfig, cardFrameConfig = _state.cardFrameConfig;
    var getConfigsAndUtils = data.utilities.getConfigsAndUtils;
    var _generalValues = getConfigsAndUtils().generalValues, oneGridCellGeometry = _generalValues.oneGridCellGeometry, sectionColors = _generalValues.sectionColors;
    return iterableList === null || iterableList === void 0 ? void 0 : iterableList.map(function(columnData, index) {
        return (columnData === null || columnData === void 0 ? void 0 : columnData.isVisible) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MultiColumn, {
            index: index,
            columnData: columnData,
            oneGridCellGeometry: oneGridCellGeometry,
            listPresentationConfig: listPresentationConfig,
            cardFrameConfig: cardFrameConfig,
            sectionColors: sectionColors
        }, index) : null;
    });
}


/***/ }),

/***/ 94078:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "TV": function() { return /* binding */ getDescriptionStyle; },
/* harmony export */   "eK": function() { return /* binding */ getDateStyle; },
/* harmony export */   "ij": function() { return /* binding */ getTitleStyles; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var getTitleStyles = function(config, isMobile) {
    var style = {};
    var currFontType = isMobile ? config === null || config === void 0 ? void 0 : config.titleSizeMobile : config === null || config === void 0 ? void 0 : config.titleSizeDesktop;
    switch(currFontType){
        case "extraSmall":
            style.fontSize = "12px";
            style.lineHeight = "1";
            break;
        case "small":
            style.fontSize = "14px";
            style.lineHeight = "1";
            break;
        case "medium":
            style.fontSize = "16px";
            style.lineHeight = "1.2";
            break;
        case "large":
            style.fontSize = "18px";
            style.lineHeight = "1.2";
            break;
        case "extraLarge":
            style.fontSize = "20px";
            style.lineHeight = "1.2";
            break;
        default:
            style.fontSize = "16px";
            style.lineHeight = "1.1";
            break;
    }
    switch(config === null || config === void 0 ? void 0 : config.titleThicness){
        case "thin":
            style.fontWeight = "300";
            break;
        case "regular":
            style.fontWeight = "400";
            break;
        case "medium":
            style.fontWeight = "500";
            break;
        case "bold":
            style.fontWeight = "700";
            break;
        default:
            style.fontWeight = "400";
            break;
    }
    switch(config === null || config === void 0 ? void 0 : config.titleTextCase){
        case "none":
            style.textTransform = "none";
            break;
        case "capitalize":
            style.textTransform = "capitalize";
            break;
        case "uppercase":
            style.textTransform = "uppercase";
            break;
    }
    return {
        style: style
    };
};
var getDescriptionStyle = function(config, isMobile) {
    var style = {};
    var currFontType = isMobile ? config === null || config === void 0 ? void 0 : config.descriptionSizeMobile : config === null || config === void 0 ? void 0 : config.descriptionSizeDesktop;
    switch(currFontType){
        case "extraSmall":
            style.fontSize = "12px";
            style.lineHeight = "1";
            break;
        case "small":
            style.fontSize = "14px";
            style.lineHeight = "1";
            break;
        case "medium":
            style.fontSize = "16px";
            style.lineHeight = "1.2";
            break;
        case "large":
            style.fontSize = "18px";
            style.lineHeight = "1.2";
            break;
        case "extraLarge":
            style.fontSize = "20px";
            style.lineHeight = "1.2";
            break;
        default:
            style.fontSize = "16px";
            style.lineHeight = "1.1";
            break;
    }
    switch(config === null || config === void 0 ? void 0 : config.descriptionThicness){
        case "thin":
            style.fontWeight = "300";
            break;
        case "regular":
            style.fontWeight = "400";
            break;
        case "medium":
            style.fontWeight = "500";
            break;
        case "bold":
            style.fontWeight = "700";
            break;
        default:
            style.fontWeight = "400";
            break;
    }
    switch(config === null || config === void 0 ? void 0 : config.descriptionTextCase){
        case "none":
            style.textTransform = "none";
            break;
        case "capitalize":
            style.textTransform = "capitalize";
            break;
        case "uppercase":
            style.textTransform = "uppercase";
            break;
    }
    return {
        style: style
    };
};
var getDateStyle = function(config, isMobile) {
    var style = {};
    var currFontType = config === null || config === void 0 ? void 0 : config.dateSize;
    switch(currFontType){
        case "extraSmall":
            style.fontSize = "12px";
            style.lineHeight = "1";
            break;
        case "small":
            style.fontSize = "14px";
            style.lineHeight = "1";
            break;
        case "medium":
            style.fontSize = "16px";
            style.lineHeight = "1.2";
            break;
        case "large":
            style.fontSize = "18px";
            style.lineHeight = "1.2";
            break;
        case "extraLarge":
            style.fontSize = "20px";
            style.lineHeight = "1.2";
            break;
        default:
            style.fontSize = "16px";
            style.lineHeight = "1.1";
            break;
    }
    switch(config === null || config === void 0 ? void 0 : config.dateThicness){
        case "thin":
            style.fontWeight = "300";
            break;
        case "regular":
            style.fontWeight = "400";
            break;
        case "medium":
            style.fontWeight = "500";
            break;
        case "bold":
            style.fontWeight = "700";
            break;
        default:
            style.fontWeight = "400";
            break;
    }
    switch(config === null || config === void 0 ? void 0 : config.dateTextCase){
        case "none":
            style.textTransform = "none";
            break;
        case "capitalize":
            style.textTransform = "capitalize";
            break;
        case "uppercase":
            style.textTransform = "uppercase";
            break;
    }
    return {
        style: style
    };
};


/***/ }),

/***/ 74232:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ EditableText; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var src_components_WidgetMaker_WidgetDnD_components_TiptapTextEditor_TiptapTextEditor__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11293);
/* harmony import */ var _tiptap_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45823);
/* harmony import */ var src_components_WidgetMaker_WidgetDnD_components_TiptapTextEditor_ToolbarMenu__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82522);





function EditableText(param) {
    var _content = param.content, content = _content === void 0 ? "" : _content, _maxLength = param.maxLength, maxLength = _maxLength === void 0 ? undefined : _maxLength, _disabled = param.disabled, disabled = _disabled === void 0 ? true : _disabled, _className = param.className, className = _className === void 0 ? "" : _className, _style = param.style, style = _style === void 0 ? {} : _style;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_WidgetMaker_WidgetDnD_components_TiptapTextEditor_TiptapTextEditor__WEBPACK_IMPORTED_MODULE_2__/* .TiptapTextEditor */ .C, {
        content: content,
        // onTextUpdate={({text}) => onChange('subHeading', text)}
        maxLength: maxLength,
        disabled: disabled,
        className: className,
        style: style,
        renderToolbarProps: function(editor) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_tiptap_react__WEBPACK_IMPORTED_MODULE_4__/* .BubbleMenu */ .NM, {
                editor: editor,
                tippyOptions: {
                    duration: 100
                },
                shouldShow: function(props) {
                    return props.editor.isFocused;
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "floating-menu",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_WidgetMaker_WidgetDnD_components_TiptapTextEditor_ToolbarMenu__WEBPACK_IMPORTED_MODULE_3__/* .ToolbarMenu */ .H, {
                        editor: editor,
                        showFormattors: false
                    })
                })
            });
        }
    });
}


/***/ }),

/***/ 35400:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ getTitleWithoutTags; }
/* harmony export */ });
/* harmony import */ var _checkRenderEnv__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6337);

var getTitleWithoutTags = function(title) {
    if (_checkRenderEnv__WEBPACK_IMPORTED_MODULE_0__/* .IS_SERVER */ .W6) {
        return title;
    }
    var htmlString = title;
    var tempDiv = document.createElement("div");
    tempDiv.innerHTML = htmlString;
    var text = tempDiv.textContent || tempDiv.innerText;
    return text;
};


/***/ }),

/***/ 96268:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"custom-border-radius":"multiColumn_custom-border-radius__fktgr"};

/***/ })

}]);